<template>
	<div>
		<div class="sim-btn">
			<button type="button" class="btn btn-primary" @click="simGo">建物倒壊シミュレータ（CAD版）へ進む</button>
		</div>
		<div class="sim-text" v-html="simText"></div>
		<GlobalEvents
			@keydown.enter.exact="simGo"
		/>
	</div>
</template>

<script>
import {JSFrame} from 'jsframe';
import GlobalEvents from 'vue-global-events';

const jsFrame = new JSFrame();

export default {
	components: {
		GlobalEvents
	},
	data() {
		return {
		}
	},
	props: {
		'mapData': {
			type: Object
		}
	},
	methods: {
		simGo: function() {
			//中心点の震度取得
			this.$emit('centerGetLeft');
			
			//震度の値取得
			console.log("si value : "+this.mapData.si);
			console.log("mcode : "+this.mapData.mcode);
			if (this.mapData.si && this.mapData.mcode) {
				if(confirm("地図の中心地点で建物倒壊シミュレータ（CAD版）を開始しますか？")) {
					var href = this.simCadUrl + "ground.cgi?si="+ this.mapData.si+"&mcode="+this.mapData.mcode;
					window.open(href, "_blank");
				}
			}
		}
	},
	computed: {
		simText: function(){
			var text = '';
			if (this.mapData.si) {
				text = '地図をドラッグしたり、ズームしたりして、地図の中心をシミュレーションしたい場所（ご自宅の位置）に合わせてください。<br>'
					+'地図を合わせてから、マップ中央上の「建物倒壊シミュレータ（CAD版）へ進む」ボタンを押してください。';
			}else{
				text = '地図の中心位置に震度データがありません。<br>愛知県内のエリアに移動してからマップ中央上の「建物倒壊シミュレータ（CAD版）へ進む」ボタンを押してください。';
			}
			return text;
		}
	}
}
</script>

<style scoped>
@import "../../css/Simulator.css";
</style>
